'use client';
import ErrorLayout, { ErrorType } from '@/components/common/ErrorLayout';
import UpdateRequiredLayout from '@/components/common/UpdateRequiredLayout';
import { useChunkErrorVersionCheck } from '@/helper/useChunkErrorVersionCheck';
import React from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}): React.JSX.Element | null {
  // Same chunk-error guard as the segment-level error boundary —
  // see `error.tsx` for rationale.
  const probe = useChunkErrorVersionCheck(error);
  if (probe === 'probing') {
    return null;
  }
  if (probe === 'version-changed') {
    return <UpdateRequiredLayout />;
  }
  console.error(error);
  return <ErrorLayout type={ErrorType.GLOBAL} countdown={20} error={error} reset={reset} />;
}
